import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { AppStateType } from '@lib/core/service/types/appStateType';

export const useTypedSelector: TypedUseSelectorHook<AppStateType> = useSelector;
